export default "__VITE_ASSET__CxG5X0LH__"